import type { Messages } from './en';

/** German UI messages. Prototype draft: needs native-speaker review before any pilot (PROJECT_STATUS K15). */
export const de: Messages = {
  'shell.skipLink': 'Zum Inhalt springen',
  'shell.brand': 'Kids World',
  'shell.brandTag': 'Prototyp',
  'shell.navLabel': 'Hauptmenü',
  'shell.menu': 'Menü',
  'shell.closeMenu': 'Menü schließen',
  'shell.broadcaster': 'Sender',
  'shell.language': 'Sprache',
  'shell.help': 'Hilfe',
  'shell.disclaimer':
    'Kids World ist ein vorläufiger Konzept-Prototyp. Alle gezeigten Sender, Sendungen und Personen sind fiktiv. Es ist kein Angebot der EBU oder ihrer Mitglieder und impliziert keine Unterstützung durch sie.',
  'shell.helpAndData': 'Hilfe und deine Daten',
  'shell.loading': 'Wird geladen …',

  'nav.discover': 'Stadt',
  'nav.watch': 'Ansehen',
  'nav.play': 'Spielen',
  'nav.create': 'Gestalten',
  'nav.projects': 'Meine Projekte',
  'nav.skills': 'Meine Fähigkeiten',

  'error.retry': 'Erneut versuchen',
  'error.code': 'Fehler {code}.',
  'error.WEB-NAV-001': 'Diese Seite gibt es nicht. Geh zurück zu Entdecken.',
  'notFound.title': 'Seite nicht gefunden',
  'notFound.back': 'Zurück zum Start',
  'error.generic': 'Bei uns hat etwas nicht geklappt. Versuche es gleich noch einmal.',
  'error.WEB-API-001':
    'Kids World ist gerade nicht erreichbar. Prüfe deine Verbindung und versuche es erneut.',
  'error.API-DB-001':
    'Sendungen können gerade nicht geladen werden. Versuche es gleich noch einmal.',
  'error.API-RATE-001': 'Zu viele Anfragen auf einmal. Warte kurz und versuche es dann erneut.',
  'error.CONTENT-CONFIG-001':
    'Diesen Sender haben wir nicht gefunden. Wähle einen anderen aus der Liste.',
  'error.CONTENT-CATALOGUE-001':
    'Diese Sendung ist für den gewählten Sender nicht gelistet. Wähle eine andere Sendung aus dem Katalog.',
  'error.WEB-STORAGE-001':
    'Dieser Browser kann gerade nichts speichern. Du kannst trotzdem schauen und entdecken; deine Auswahl gilt, bis du die Seite schließt.',

  'discover.title': 'Entdecken',
  'discover.intro': 'Sendungen ansehen, spielen und selbst etwas bauen — ohne Anmeldung.',
  'discover.startExploring': 'Los geht’s',
  'discover.featured': 'Empfohlen von {broadcaster}',
  'discover.watch': 'Ansehen',
  'discover.noItems': 'Dieser Sender hat gerade keine Sendungen gelistet.',
  'rail.fromBroadcasters': 'Von unseren Sendern',
  'rail.fromBroadcastersNote': 'Ausgewählt und sortiert von der Redaktion von {broadcaster}.',
  'rail.playWithStory': 'Spielen mit einer Geschichte',
  'rail.playWithStoryNote': 'Sendungen, zu denen es ein Spiel gibt.',
  'rail.makeSomething': 'Selbst etwas bauen',
  'rail.makeSomethingNote': 'Sendungen übers Bauen, Basteln und Ausprobieren.',
  'rail.empty': 'Bei diesem Sender gibt es hier noch nichts.',
  'rail.previous': 'Vorherige Sendungen zeigen',
  'rail.next': 'Weitere Sendungen zeigen',
  'rail.seeAll': 'Alle Sendungen',

  'data.title': 'Deine Daten auf diesem Gerät',
  'data.body':
    'Du kannst Kids World ohne Konto nutzen. Deine Auswahl (Sender, Sprache und, wenn du willst, Interessen) und alles, was du baust, wird nur in diesem Browser gespeichert. An uns wird nichts gesendet.',
  'data.warning':
    'Browser können gespeicherte Daten löschen, zum Beispiel im privaten Modus oder wenn Website-Daten gelöscht werden. Exportiere Projekte, die du behalten möchtest.',
  'data.nothingSaved': 'In diesem Browser ist noch nichts gespeichert.',
  'data.savedChoices': 'Deine Auswahl ist in diesem Browser gespeichert.',
  'data.projects.one': '{count} gespeichertes Projekt',
  'data.projects.other': '{count} gespeicherte Projekte',
  'data.clear': 'Meine Daten löschen',
  'data.clearTitle': 'Deine Daten in diesem Browser löschen?',
  'data.clearBody':
    'Damit werden deine gespeicherte Auswahl, deine Projekte und dein Fortschritt aus diesem Browser entfernt. Exportiere vorher alle Projekte, die du behalten möchtest. Das kann nicht rückgängig gemacht werden.',
  'data.cancel': 'Abbrechen',
  'data.cleared': 'Deine Daten in diesem Browser wurden gelöscht.',

  'card.ages': '{min}–{max} Jahre',
  'card.minutes': 'Etwa {minutes} Min.',
  'card.episode': 'Staffel {season}, Folge {episode}',
  'card.audio': 'Ton: {languages}',
  'card.captions': 'Untertitel: {languages}',
  'card.noCaptions': 'Noch keine Untertitel',
  'card.origin': 'Von {origin}',
  'card.game': 'Mit Spiel',
  'card.fictional': 'Fiktives Beispiel',
  'card.textLanguage': 'Text auf {language}',
  'availability.playable': 'Bereit zum Ansehen',
  'availability.media-missing': 'Video noch nicht verfügbar',
  'availability.not-streamable': 'Nur gelistet, hier nicht abspielbar',
  'availability.rights-not-started': 'Verfügbar ab {date}',

  'format.episode': 'Folge',
  'format.short': 'Kurzfilm',
  'format.special': 'Spezial',
  'format.clip': 'Clip',
  'topic.science': 'Wissenschaft',
  'topic.nature': 'Natur',
  'topic.stories': 'Geschichten',
  'topic.making': 'Bauen',
  'topic.music': 'Musik',
  'topic.sport': 'Sport',
  'topic.history': 'Geschichte',
  'topic.animals': 'Tiere',
  'warning.mild-peril': 'Leichte Spannung',
  'warning.loud-noises': 'Laute Geräusche',
  'warning.flashing-lights': 'Blinkende Lichter',
  'warning.darkness': 'Dunkle Szenen',
  'credit.production': 'Produktion',
  'credit.commissioning-member': 'Beauftragendes Mitglied',
  'credit.creator-collaboration': 'Zusammenarbeit mit Kreativen',
  'credit.voice': 'Stimme',
  'credit.music': 'Musik',

  'watch.title': 'Ansehen',
  'watch.intro': 'Alle Sendungen von {broadcaster}, in der Reihenfolge der Redaktion.',
  'filter.legend': 'Sendung finden',
  'filter.search': 'Suche',
  'filter.searchHint': 'Wörter aus Titel oder Beschreibung',
  'filter.topics': 'Interessen',
  'filter.age': 'Alter',
  'filter.ageAny': 'Jedes Alter',
  'filter.format': 'Art',
  'filter.formatAny': 'Jede Art',
  'filter.clear': 'Filter zurücksetzen',
  'filter.remember': 'Meine Interessen in diesem Browser merken',
  'filter.rememberHint':
    'Freiwillig. Wird nur auf diesem Gerät gespeichert und nirgendwohin gesendet.',
  'watch.results.one': '{count} Sendung',
  'watch.results.other': '{count} Sendungen',
  'watch.noResults': 'Keine Sendung passt zu dieser Auswahl.',
  'watch.noResultsHint': 'Versuche weniger Interessen, ein anderes Alter oder andere Wörter.',

  'programme.back': 'Alle Sendungen',
  'programme.details': 'Details',
  'programme.made': 'Gemacht von',
  'programme.credits': 'Mitwirkende',
  'programme.goodToKnow': 'Gut zu wissen',
  'programme.languages': 'Sprachen',
  'programme.series': 'Folgen dieser Serie',
  'programme.thisEpisode': 'Diese Folge',
  'programme.playable': 'Diese Sendung darf hier gezeigt werden.',
  'programme.unavailable.media-missing':
    'Das Video zu dieser Sendung ist noch nicht verfügbar. Du kannst darüber lesen und andere Sendungen entdecken.',
  'programme.unavailable.not-streamable':
    'Diese Sendung darf hier gelistet werden, kann aber in Kids World nicht abgespielt werden.',
  'programme.unavailable.rights-not-started': 'Diese Sendung kann ab {date} angesehen werden.',
  'programme.whatNext': 'Wie geht’s weiter?',
  'programme.moreProgrammes': 'Weitere Sendungen entdecken',
  'programme.backToDiscover': 'Zurück in die Stadt',

  'place.cinema': 'Kino',
  'place.cinemaNote': 'Sieh dir Sendungen an, die die Redaktion ausgewählt hat.',
  'place.lab': 'Entdeckerlabor',
  'place.labNote': 'Löse Stromkreis-Aufgaben zu unseren Geschichten.',
  'place.tower': 'Europa-Globus',
  'place.towerNote': 'Wähle deinen Sender und deine Sprache.',
  'place.workshop': 'Bastelhof',
  'place.workshopNote': 'Baue Dinge in 3D.',
  'place.treehouse': 'Baumhaus',
  'place.treehouseNote': 'Deine Projekte und Fähigkeiten, in diesem Browser gespeichert.',
  'hub.title': 'Kids-World-Stadt',
  'hub.welcomeTitle': 'Willkommen bei Kids World',
  'hub.welcomeBody':
    'Entdecke die Stadt. Im Kino kannst du Sendungen ansehen, im Labor Stromkreis-Aufgaben lösen, im Bastelhof bauen und am Europa-Globus deinen Sender wählen; im Baumhaus siehst du deine Projekte und Fähigkeiten. Ohne Anmeldung.',
  'hub.startExploring': 'Los geht’s',
  'hub.placesLabel': 'Orte in der Stadt',
  'hub.goIn': 'Hineingehen',
  'hub.lookInside': 'Anschauen',
  'hub.building': 'Im Bau',
  'hub.keysHint': 'Mit den Pfeiltasten wählst du einen Ort. Enter geht hinein.',
  'hub.previousPlace': 'Vorheriger Ort',
  'hub.nextPlace': 'Nächster Ort',
  'hub.nowShowing': 'Jetzt im Kino',
  'hub.loading3d': 'Die Stadt wird gebaut …',
  'hub.useMap': 'Einfache Karte',
  'hub.use3d': '3D-Stadt',
  'hub.mapTitle': 'Stadtplan',
  'error.WORLD-RENDER-001':
    'Dein Browser kann die 3D-Stadt nicht anzeigen. Die einfache Karte funktioniert genauso.',
  'poster.sample': 'Fiktives Beispiel',
  'data.close': 'Schließen',
  'data.open': 'Meine Daten',
  'cinema.title': 'Kino',
  'cinema.back': 'Zurück in die Stadt',
  'cinema.interests': 'Was magst du?',
  'cinema.everything': 'Alles',
  'cinema.allAges': 'Jedes Alter',
  'cinema.allTypes': 'Alle Arten',
  'cinema.shelfAll': 'Alle Sendungen',
  'cinema.shelfGames': 'Geschichten mit Spiel',
  'cinema.shelfMaking': 'Bauen und basteln',
  'cinema.results': 'Sendungen für dich',
  'tower.title': 'Europa-Globus',
  'tower.intro':
    'Jeder Sender wählt Sendungen für sein eigenes Land aus. Deine gespeicherten Sachen bleiben, wenn du wechselst.',
  'tower.choose': 'Wähle einen Sender',
  'tower.selected': 'Ausgewählt',
  'tower.languages': 'Sprachen',
  'hub.canvasLabel':
    '3D-Stadt. Laufe mit W A S D oder den Pfeiltasten, ziehe zum Umsehen und drücke an einer Tür Enter, um hineinzugehen.',
  'hub.pressEnter': 'Du stehst an der Tür. Drücke Enter, um hineinzugehen.',
  'hub.walkHint': 'W A S D oder Pfeile zum Laufen · ziehen zum Umsehen · scrollen zum Zoomen',
  'player.label': 'Videoplayer',
  'player.play': 'Abspielen',
  'player.start': 'Sendung abspielen',
  'player.pause': 'Pause',
  'player.back10': '10 Sekunden zurück',
  'player.forward10': '10 Sekunden vor',
  'player.mute': 'Stumm',
  'player.unmute': 'Ton an',
  'player.volume': 'Lautstärke',
  'player.seek': 'Stelle in der Sendung',
  'player.time': '{current} von {total}',
  'player.captions': 'Untertitel',
  'player.captionsOff': 'Aus',
  'player.fullscreen': 'Vollbild',
  'player.exitFullscreen': 'Vollbild beenden',
  'player.keys':
    'Tasten: Leertaste abspielen oder pausieren · ← → 5 Sekunden · ↑ ↓ Lautstärke · M stumm · C Untertitel · F Vollbild',
  'player.loading': 'Das Video lädt …',
  'player.watchAgain': 'Noch einmal ansehen',
  'player.captionsFailed': 'Die Untertitel konnten nicht geladen werden.',
  'player.retry': 'Erneut versuchen',
  'end.title': 'Ende. Wie geht’s weiter?',
  'end.body': 'Du kannst hier aufhören oder dir etwas Neues aussuchen.',
  'programme.nextGame': 'Als Nächstes: Probier die Stromkreis-Aufgabe',
  'programme.createWorkshop': 'In der Werkstatt gestalten',
  'programme.playGame': 'Zum Spiel',
  'card.noSpeech': 'Keine Sprache: Musik und Geräusche',
  'error.CONTENT-MEDIA-002':
    'Dieses Video konnte nicht abgespielt werden. Versuche es erneut oder wähle stattdessen ein Spiel oder die Werkstatt.',
  'shell.fictionalBar':
    'Prototyp · alle Sender, Sendungen und Personen sind erfunden · kein Angebot der EBU oder ihrer Mitglieder',
  'shell.searchHint': 'Sendungen suchen',
  'nav.cinema': 'Kino',
  'nav.lab': 'Labor',
  'nav.workshop': 'Werkstatt',
  'nav.myStuff': 'Meine Sachen',
  'cinema.featured': 'Empfohlen',
  'cinema.featuredGame': 'Empfohlen · mit Spiel',
  'cinema.watchNow': 'Jetzt ansehen',
  'cinema.tryChallenge': 'Aufgabe ausprobieren',
  'cinema.aboutIt': 'Mehr dazu',
  'cinema.rowAll': 'Alle Sendungen von {broadcaster}',
  'cinema.rowAllNote': 'In der Reihenfolge der Redaktion',
  'cinema.rowGames': 'Erst schauen, dann spielen',
  'cinema.rowGamesNote': 'Geschichten mit einer Aufgabe im Labor',
  'cinema.rowMaking': 'Bauen und basteln',
  'cinema.rowMakingNote': 'Sendungen übers Bauen, Basteln und Ausprobieren',
  'cinema.rowLiked': 'Weil du {topics} magst',
  'cinema.rowLikedNote': 'Nach den Interessen, die du auf diesem Gerät gespeichert hast',
  'cinema.showAll': 'Alle zeigen',
  'search.title': 'Sendungen',
  'search.resultsFor': 'Ergebnisse für „{query}“',
  'search.filters': 'Filter',
  'search.topics': 'Interessen',
  'card.thumbFictional': 'Erfunden',
  'programme.crumbs': 'Du bist hier',
  'programme.side': 'Folgen und Aktivitäten',
  'programme.seasonTitle': 'Staffel {season}',
  'programme.itemVideo': 'Video · {duration}',
  'programme.watchingNow': 'Läuft gerade',
  'programme.challengeItem': 'Aufgabe: {title}',
  'programme.challengeMeta': 'Spiel im Labor',
  'programme.buildItem': 'Etwas in der Werkstatt bauen',
  'programme.buildMeta': 'Werkstatt',
  'programme.stopAnyTime': 'Du kannst jederzeit aufhören. Es startet nichts von selbst.',
  'programme.tabOverview': 'Überblick',
  'programme.tabLanguages': 'Sprachen',
  'programme.tabAbout': 'Info',
  'programme.learn': 'Das erfährst du',
  'objective.closedLoop': 'Eine Lampe leuchtet nur, wenn der Stromkreis geschlossen ist',
  'objective.switchControl': 'Ein Schalter öffnet und schließt den Stromkreis',
  'objective.faultDiagnosis': 'Wie man die Lücke in einem kaputten Stromkreis findet',
  'objective.sensorLogic': 'Wie ein Licht von selbst angeht, wenn es dunkel wird',
  'game.lab.title': 'Entdeckerlabor',
  'game.lab.intro':
    'Löse Stromkreis-Aufgaben zu unseren Geschichten. Verbinde Batterien, Schalter und Lampen. Es gibt keine Zeitmessung und keine Punkte.',
  'game.lab.none': 'Es sind noch keine Aufgaben veröffentlicht.',
  'game.lab.start': 'Los geht’s',
  'game.lab.challenges.one': '{count} Aufgabe',
  'game.lab.challenges.other': '{count} Aufgaben',
  'game.loading': 'Die Aufgabe lädt …',
  'game.backToLab': 'Zurück ins Labor',
  'game.part.battery': 'Batterie',
  'game.part.lamp': 'Lampe',
  'game.part.switch': 'Schalter',
  'game.part.light-sensor': 'Lichtsensor',
  'game.end.plus': '+-Ende',
  'game.end.minus': '−-Ende',
  'game.end.left': 'linkes Ende',
  'game.end.right': 'rechtes Ende',
  'game.terminal': '{part}, {end}',
  'game.find.short-circuit':
    'Kurzschluss! Ein Kabel geht von + nach − ohne Lampe dazwischen, die Batterie würde heiß. Entferne dieses Kabel.',
  'game.find.battery-unconnected': 'Die Batterie ist noch mit nichts verbunden.',
  'game.find.gap': 'Im Kreis ist eine Lücke. Nicht verbunden ist: {ends}.',
  'game.find.lamp-bypassed':
    'Ein Kabel verbindet beide Enden von {lamp}, darum fließt der Strom an der Lampe vorbei statt hindurch.',
  'game.find.switch-open': '{switches} ist aus, darum ist der Kreis offen.',
  'game.find.sensor-off': 'Es ist Tag, darum lässt der Lichtsensor keinen Strom durch.',
  'game.find.hidden-fault':
    'Alles sieht verbunden aus, aber etwas im Kreis lässt keinen Strom durch.',
  'game.find.hidden-fault-tester':
    'Alles sieht verbunden aus, aber etwas im Kreis lässt keinen Strom durch. Finde es mit dem Prüfgerät.',
  'game.find.dim':
    '{lamp} leuchtet nur schwach: Sie teilt sich die Batterie mit einer anderen Lampe im selben Kreis.',
  'game.find.not-controlled-switch':
    '{lamp} bleibt an, auch wenn ihr Schalter aus ist: Der Schalter ist nicht in ihrem Kreis.',
  'game.find.not-controlled-sensor':
    '{lamp} bleibt bei Tageslicht an: Der Lichtsensor ist nicht in ihrem Kreis.',
  'game.find.unknown': 'Noch nicht ganz. Schau dir die Lampen an und versuche es noch einmal.',
  'game.cond.night': 'nachts',
  'game.cond.day': 'am Tag',
  'game.cond.switchOn': 'mit {switch} an',
  'game.cond.switchOff': 'mit {switch} aus',
  'game.cond.lead': '(Geprüft {conditions}.)',
  'game.refused.same-terminal': 'Wähle ein anderes Ende.',
  'game.refused.already-connected': 'Diese beiden Enden sind schon verbunden.',
  'game.refused.no-wires-left':
    'Keine Kabel mehr in der Kiste. Entferne ein Kabel, um es wieder zu benutzen.',
  'game.connected': 'Kabel verbunden: {from} mit {to}.',
  'game.selected': '{terminal} gewählt. Wähle jetzt, wohin das Kabel geht.',
  'game.cancelled': 'Kabel abgebrochen.',
  'game.restarted': 'Das Brett ist wieder wie am Anfang.',
  'game.on': 'an',
  'game.off': 'aus',
  'game.dim': 'schwach',
  'game.lampStatus': '{lamp}: {state}',
  'game.boardHelp':
    'Wähle ein Ende und dann ein zweites, um sie mit einem Kabel zu verbinden (oder ziehe von einem zum anderen). Esc bricht ab. Klicke auf einen Schalter, um ihn umzulegen.',
  'game.shortWarning': 'Kurzschluss! Die Batterie ist direkt von + nach − verbunden.',
  'game.wiresLeft.one': '{count} Kabel in der Kiste',
  'game.wiresLeft.other': '{count} Kabel in der Kiste',
  'game.daylight': 'Tag oder Nacht',
  'game.night': 'Nacht',
  'game.day': 'Tag',
  'game.connections': 'Kabel und Teile',
  'game.connectForm': 'Zwei Enden verbinden',
  'game.from': 'Von',
  'game.to': 'Nach',
  'game.connect': 'Verbinden',
  'game.noWires': 'Noch keine Kabel auf dem Brett.',
  'game.test.ok': 'Das Prüfgerät piept: Das funktioniert.',
  'game.test.broken': 'Kein Piepen: Das ist kaputt!',
  'game.testWire': 'Kabel {wire} prüfen',
  'game.testLamp': '{lamp} prüfen',
  'game.testPart': 'Prüfen',
  'game.removeWire': 'Kabel {wire} entfernen',
  'game.removed': 'Kabel entfernt: {wire}.',
  'game.remove': 'Entfernen',
  'game.parts': 'Teile',
  'game.lampReplaced': 'Eine neue Lampe ist drin.',
  'game.replaceLamp': 'Neue Lampe',
  'game.level': 'Stufe {level}',
  'game.goal': 'Dein Ziel',
  'game.test': 'Stromkreis prüfen',
  'game.success': 'Geschafft!',
  'game.attempts.one': 'Gelöst nach {count} Prüfung.',
  'game.attempts.other': 'Gelöst nach {count} Prüfungen.',
  'game.notYet': 'Noch nicht',
  'game.noMoreHints': 'Keine weiteren Tipps',
  'game.hint': 'Tipp zeigen',
  'game.startAgain': 'Neu anfangen',
  'game.easier': 'Etwas Leichteres',
  'game.harder': 'Etwas Schwierigeres',
  'game.challengeList': 'Aufgaben',
  'game.solvedMark': 'Erledigt',
  'error.GAME-CIRCUIT-001':
    'Diese Aufgabe konnte nicht geladen werden. Probiere eine andere Aufgabe.',
  'error.GAME-MISSION-001': 'Diese Aufgabe ist nicht verfügbar. Wähle im Labor eine andere.',
  'learn.why': 'Warum diese Aufgabe?',
  'learn.next': 'Weiter: {title}',
  'learn.reason.start': 'Hier fangen alle an.',
  'learn.reason.start-harder':
    'Du hast gesagt, dass du schon Stromkreise gebaut hast, darum startest du eine Stufe höher.',
  'learn.reason.step-up':
    'Du hast „{challenge}“ allein gelöst, darum kommt jetzt eine schwierigere Aufgabe zur selben Idee.',
  'learn.reason.next-idea': 'Zeit für eine neue Idee.',
  'learn.reason.next-idea-help':
    '„{challenge}“ hat etwas Hilfe gebraucht, darum kommst du später auf diese Idee zurück. Zuerst eine neue Idee.',
  'learn.reason.fast-track':
    'Du hast zwei schwierigere Aufgaben hintereinander allein gelöst, darum beginnt diese neue Idee auf der schwierigeren Stufe.',
  'learn.reason.step-down':
    '„{challenge}“ ist noch nicht gelöst, darum hilft vielleicht diese leichtere Aufgabe zur selben Idee.',
  'learn.reason.try-again':
    '„{challenge}“ ist noch nicht gelöst. Noch ein Versuch ist eine gute Idee.',
  'learn.reason.revisit': 'Zurück zu einer Idee, die vorhin etwas Hilfe gebraucht hat.',
  'learn.reason.all-shown':
    'Du hast alle Ideen allein gezeigt. Wähle eine Aufgabe, die dir gefällt.',
  'learn.reason.your-choice': 'Du hast diese Aufgabe selbst gewählt. Das ist gut so!',
  'learn.obj.closed-loop': 'Geschlossene Kreise',
  'learn.obj.switch-control': 'Schalter',
  'learn.obj.fault-diagnosis': 'Fehler finden',
  'learn.obj.sensor-logic': 'Lichtsensor',
  'learn.status.unobserved': 'Noch nicht versucht',
  'learn.status.emerging': 'Am Anfang',
  'learn.status.practised': 'Geübt',
  'learn.status.demonstrated': 'Allein gezeigt',
  'learn.savePrompt.title': 'Deinen Fortschritt in diesem Browser merken?',
  'learn.savePrompt.body':
    'Er wird nur in diesem Browser gespeichert und nie an uns geschickt. Du kannst ihn jederzeit unter „Meine Daten“ löschen.',
  'learn.savePrompt.yes': 'Ja, speichern',
  'learn.savePrompt.no': 'Nein, danke',
  'learn.saving': 'Wird in diesem Browser gespeichert …',
  'learn.saved': 'Dein Fortschritt ist nur in diesem Browser gespeichert.',
  'learn.notSaved': 'Dein Fortschritt bleibt nur, bis du die Seite schließt oder neu lädst.',
  'learn.start.title': 'Wo möchtest du anfangen?',
  'learn.start.beginning': 'Von vorn',
  'learn.start.harder': 'Ich habe schon Stromkreise gebaut',
  'learn.start.note': 'Du kannst immer eine andere Aufgabe wählen.',
  'learn.progress.title': 'Was du geübt hast',
  'learn.progress.none': 'Noch nichts versucht. Dein Fortschritt erscheint hier.',
  'learn.progress.about':
    'Noch nicht versucht → Am Anfang → Geübt → Allein gezeigt. „Allein gezeigt“ heißt, dass du die schwierigere Aufgabe mit höchstens einem Tipp und drei Prüfungen gelöst hast.',
  'learn.ev.solved': '„{challenge}“: gelöst · Prüfungen: {tests} · Tipps: {hints} · {date}',
  'learn.ev.notYet': '„{challenge}“: noch nicht gelöst · Prüfungen: {tests} · {date}',
  'learn.provisional.one': 'Eine erste Einschätzung aus {count} Aufgabe, keine Note.',
  'learn.provisional.other': 'Eine erste Einschätzung aus {count} Aufgaben, keine Note.',
  'learn.continue': 'Weiter: {title}',
  'error.LEARN-EVIDENCE-001':
    'Dein Fortschritt konnte in diesem Browser nicht gespeichert werden. Du kannst weiterspielen.',
  'ws.title': 'Werkstatt im Bastelhof',
  'ws.toolbar': 'Werkstatt-Aktionen',
  'ws.save': 'Speichern',
  'ws.open': 'Öffnen',
  'ws.undo': 'Rückgängig',
  'ws.redo': 'Wiederholen',
  'ws.export': 'Exportieren',
  'ws.help': 'Hilfe',
  'ws.isSaved': 'In diesem Browser gespeichert',
  'ws.unsaved': 'Noch nicht gespeichert',
  'ws.saving': 'Wird gespeichert …',
  'ws.inventory': 'Teile',
  'ws.addHint':
    'Wähle ein Teil, um es in den Raum zu stellen. Dann ziehe es oder bewege es mit den Pfeiltasten.',
  'ws.cat.circuit': 'Stromkreis-Teile',
  'ws.cat.decor': 'Dinge für den Raum',
  'ws.add': '{object} hinzufügen',
  'ws.added': '{object} hinzugefügt.',
  'ws.removed': '{object} entfernt.',
  'ws.room': 'Werkstattraum',
  'ws.view': '3D oder Plan',
  'ws.view3d': '3D',
  'ws.viewPlan': 'Plan',
  'ws.snap': 'Am Raster ausrichten',
  'ws.loading3d': 'Die Werkstatt wird gebaut …',
  'ws.zoomIn': 'Vergrößern',
  'ws.zoomOut': 'Verkleinern',
  'ws.resetCamera': 'Ansicht zurücksetzen',
  'ws.inspector': 'Eigenschaften',
  'ws.objects': 'Dinge im Raum',
  'ws.empty': 'Der Raum ist leer. Füge Teile aus der Liste links hinzu.',
  'ws.nothingSelected': 'Nichts ausgewählt. Klicke im Raum auf etwas oder wähle es hier:',
  'ws.position': 'Position',
  'ws.x': 'Links–rechts (m)',
  'ws.y': 'Höhe (m)',
  'ws.z': 'Vorne–hinten (m)',
  'ws.rotateLeft': 'Nach links drehen',
  'ws.rotateRight': 'Nach rechts drehen',
  'ws.scale': 'Größe',
  'ws.colour': 'Farbe',
  'ws.caption': 'Text auf dem Poster',
  'ws.switch': 'Schalter: {state}',
  'ws.threshold': 'Schaltet ein, wenn das Licht schwächer als diese Stufe ist',
  'ws.state': '{object}: {state}',
  'ws.wires': 'Kabel',
  'ws.connectTo': '{port} verbinden mit …',
  'ws.connect': 'Verbinden',
  'ws.removeWire': 'Kabel {wire} entfernen',
  'ws.wireRemoved': 'Kabel entfernt.',
  'ws.remove': 'Entfernen',
  'ws.duplicate': 'Kopieren',
  'ws.deselect': 'Fertig',
  'ws.portOf': '{object}, {end}',
  'ws.wireStart': 'Kabel vom {port}. Wähle jetzt, wohin es geht.',
  'ws.wireDone': 'Kabel verbunden: {from} mit {to}.',
  'ws.wireCancel': 'Kabel abgebrochen.',
  'ws.circuit.no-battery': 'Füge eine Batterie hinzu, damit Lampen und Ventilatoren funktionieren.',
  'ws.circuit.several-batteries':
    'Diese Werkstatt nutzt eine Batterie auf einmal. Entferne eine Batterie.',
  'ws.circuit.short':
    'Kurzschluss! Ein Kabel verbindet + und − ohne Lampe oder Ventilator dazwischen.',
  'ws.circuit.ok': '{on} von {total} Lampen und Ventilatoren funktionieren.',
  'ws.keys':
    'Tasten: Pfeile bewegen · R drehen (Umschalt+R zurück) · D kopieren · Entf entfernen · Strg+Z rückgängig · Strg+Y wiederholen · Esc beenden',
  'ws.saveDialog': 'Dein Projekt speichern',
  'ws.name': 'Name',
  'ws.saveHint':
    'Es wird nur in diesem Browser gespeichert. Mit Exportieren behältst du eine Kopie als Datei.',
  'ws.saved': '„{title}“ ist gespeichert.',
  'ws.cancel': 'Abbrechen',
  'ws.close': 'Schließen',
  'ws.openDialog': 'Deine Projekte',
  'ws.newProject': 'Etwas Neues anfangen',
  'ws.yourProjects': 'Gespeicherte Projekte',
  'ws.noProjects': 'Noch keine gespeicherten Projekte.',
  'ws.updated': 'Geändert am {date}',
  'ws.objectCount.one': '{count} Ding',
  'ws.objectCount.other': '{count} Dinge',
  'ws.openProject': 'Öffnen',
  'ws.openNamed': '„{title}“ öffnen',
  'ws.exportNamed': '„{title}“ exportieren',
  'ws.deleteNamed': '„{title}“ löschen',
  'ws.deleteProject': 'Löschen',
  'ws.opened': '„{title}“ ist geöffnet.',
  'ws.exported': 'Deine Projektdatei wird heruntergeladen.',
  'ws.confirmDelete': '„{title}“ löschen?',
  'ws.confirmDeleteBody':
    'Das entfernt es aus diesem Browser. Exportiere es vorher, wenn du eine Kopie behalten möchtest.',
  'ws.continue': 'Weiter',
  'ws.discardTitle': 'Ohne Speichern neu anfangen?',
  'ws.unreadable': 'Ein gespeichertes Projekt lässt sich nicht öffnen',
  'ws.downloadRaw': 'Herunterladen',
  'ws.import': 'Projektdatei öffnen (.json)',
  'ws.leave': 'Ohne Speichern gehen?',
  'ws.leaveBody': 'Deine Änderungen seit dem letzten Speichern gehen verloren.',
  'ws.stay': 'Bleiben',
  'ws.leaveConfirm': 'Gehen',
  'ws.helpTitle': 'So funktioniert die Werkstatt',
  'ws.help1':
    'Füge Teile aus der Liste links hinzu. Klicke auf etwas, um es auszuwählen, und ziehe, drehe oder ändere es rechts.',
  'ws.help2':
    'Für einen Stromkreis klickst du auf das runde Ende eines Teils und dann auf das Ende eines anderen. Eine Lampe leuchtet nur, wenn der Kreis geschlossen ist – genau wie im Labor.',
  'ws.help3':
    'Der Plan zeigt den Raum von oben und funktioniert gut mit der Tastatur. Speichern behält dein Projekt in diesem Browser; Exportieren macht eine Datei, die du behalten kannst.',
  'ws.storageUnavailable':
    'In diesem Browser kann nicht gespeichert werden (privates Surfen oder blockierter Speicher). Du kannst trotzdem bauen und exportieren.',
  'ws.dismiss': 'OK',
  'ws.posterCaption': 'Laternenraum',
  'ws.newTitle.empty': 'Mein Raum',
  'ws.newTitle.lighthouse': 'Mein Laternenraum',
  'ws.starter.empty': 'Leerer Raum',
  'ws.starter.lighthouse': 'Laternenraum im Leuchtturm',
  'ws.obj.floor-tile': 'Bodenfliese',
  'ws.obj.wall-panel': 'Wandplatte',
  'ws.obj.table': 'Tisch',
  'ws.obj.shelf': 'Regal',
  'ws.obj.plant': 'Pflanze',
  'ws.obj.rug': 'Teppich',
  'ws.obj.window': 'Fenster',
  'ws.obj.poster': 'Poster',
  'ws.obj.battery': 'Batterie',
  'ws.obj.switch': 'Schalter',
  'ws.obj.lamp': 'Lampe',
  'ws.obj.light-sensor': 'Lichtsensor',
  'ws.obj.fan': 'Ventilator',
  'ws.port.positive': '+-Ende',
  'ws.port.negative': '−-Ende',
  'ws.port.a': 'linkes Ende',
  'ws.port.b': 'rechtes Ende',
  'ws.port.in': 'Eingang',
  'ws.port.out': 'Ausgang',
  'ws.colour.natural': 'Holz',
  'ws.colour.sky': 'Himmelblau',
  'ws.colour.leaf': 'Blattgrün',
  'ws.colour.sun': 'Sonnengelb',
  'ws.colour.berry': 'Beerenrot',
  'ws.colour.slate': 'Schiefergrau',
  'ws.refused.too-many-objects': 'Der Raum ist voll (300 Dinge). Entferne zuerst etwas.',
  'ws.refused.too-many-wires': 'Es gibt zu viele Kabel (300). Entferne zuerst eines.',
  'ws.refused.same-port': 'Wähle ein anderes Ende.',
  'ws.refused.already-connected': 'Diese beiden Enden sind schon verbunden.',
  'ws.refused.unknown-object': 'Das ist nicht mehr im Raum.',
  'ws.refused.not-a-port': 'Das ist kein Kabelende.',
  'ws.refused.invalid': 'Diese Änderung ist nicht möglich.',
  'error.WORLD-SAVE-001':
    'Diese Version deiner Werkstatt konnte nicht gespeichert werden. Deine letzte gespeicherte Version ist unverändert – versuche, dein Projekt zu exportieren.',
  'error.WORLD-SAVE-002':
    'Deine Werkstatt konnte nicht gespeichert werden. Exportiere dein Projekt zuerst.',
  'error.WORLD-LOAD-001':
    'Dieses gespeicherte Projekt lässt sich nicht öffnen. Es wurde behalten – du kannst es herunterladen oder löschen.',
  'error.WORLD-IMPORT-003':
    'Diese Datei ist kein Kids-World-Projekt, das wir öffnen können. Deine anderen Projekte sind unverändert.',
  'help.title': 'Hilfe',
  'help.keyboardTitle': 'Mit der Tastatur',
  'help.keyboardBody':
    'Mit der Tabulatortaste springst du zwischen Bedienelementen, mit Enter wählst du aus. Der erste Druck auf Tab bietet „Zum Inhalt springen“ an. Escape schließt ein geöffnetes Fenster.',
  'help.broadcasterTitle': 'Sender und Sprache',
  'help.broadcasterBody':
    'Wähle einen Sender, um die Sendungen zu sehen, die seine Redaktion für sein Land ausgesucht hat. Jeder Sender bietet eigene Sprachen an. Deine gespeicherten Projekte bleiben erhalten, wenn du wechselst.',
  'help.fictionalTitle': 'Was „fiktiv“ bedeutet',
  'help.fictionalBody':
    'Dies ist ein Prototyp. Die Sender, Sendungen und Personen darin sind für Tests erfunden und stehen nicht für echte Organisationen oder Kinder.',
  'tree.sections': 'Bereiche im Baumhaus',
  'tree.whose': 'Wessen Sachen gezeigt werden',
  'tree.storageUnavailable':
    'Dieser Browser kann nichts speichern (privates Surfen oder blockierter Speicher), daher gibt es hier keine gespeicherten Projekte oder Fähigkeiten.',
  'tree.fictionalTag': 'Erfundenes Beispiel',
  'tree.profile.sample-new-to-circuits': 'Beispiel-Lernende: neu bei Stromkreisen',
  'tree.profile.sample-experienced': 'Beispiel-Lernende: erfahren mit Stromkreisen',
  'tree.profileBody.sample-new-to-circuits':
    'Hat die erste Stromkreis-Aufgabe mit viel Hilfe versucht und in der Werkstatt einen Raum begonnen.',
  'tree.profileBody.sample-experienced':
    'Hat schwerere Aufgaben zu geschlossenen Kreisen und Schaltern gelöst und ein automatisches Nachtlicht gebaut.',
  'tree.sampleNote':
    'Du siehst eine erfundene Beispiel-Lernende, kein echtes Kind. Es ist eine Kopie nur in diesem Browser: Was du jetzt tust, ändert nur diese Kopie. Deine eigenen Sachen bleiben erhalten.',
  'tree.backToOwn': 'Zurück zu meinen Sachen',
  'tree.resetSample': 'Dieses Beispiel neu starten',
  'tree.removeSample': 'Dieses Beispiel entfernen',
  'tree.ownNote': 'Das sind deine eigenen Sachen, nur in diesem Browser gespeichert.',
  'tree.trySample': 'Eine Beispiel-Lernende ausprobieren',
  'tree.trySampleBody':
    'Sieh dir an, wie Labor und Baumhaus für eine erfundene Lernende aussehen. In diesem Browser wird eine private Kopie angelegt; niemand sonst sieht sie, und deine eigenen Sachen bleiben, wie sie sind.',
  'tree.useSample': 'Ausprobieren',
  'tree.openSample': 'Wieder öffnen',
  'tree.useSampleNamed': 'Ausprobieren: {profile}',
  'tree.removeTitle': 'Diese Beispiel-Lernende entfernen?',
  'tree.removeBody':
    'Ihre Kopie in diesem Browser mit Projekten und Fortschritt wird gelöscht. Du kannst jederzeit eine neue Kopie anlegen.',
  'tree.loading': 'Wird geladen …',
  'tree.projectsTitle': 'Gespeicherte Projekte',
  'tree.noProjects': 'Noch nichts gespeichert. Bau etwas im Bastelhof und speichere es.',
  'tree.goBuild': 'Zum Bastelhof',
  'tree.projectsNote':
    'Projekte werden nur in diesem Browser gespeichert. Wenn die Browserdaten gelöscht werden, sind sie weg — mit Exportieren behältst du eine Kopie.',
  'tree.skillsTitle': 'Ideen zu Stromkreisen',
  'tree.skillsIntro':
    'Was die Labor-Aufgaben bisher zeigen, Idee für Idee. Jede Zeile sagt, aus welcher Aufgabe sie stammt.',
  'tree.builtTitle': 'Mit Stromkreis-Teilen gebaut',
  'tree.notAssessed': 'Nicht bewertet',
  'tree.builtNone': 'Noch keine gespeicherten Werkstatt-Projekte mit Stromkreis-Teilen.',
  'tree.likesTitle': 'Was du magst',
  'tree.likesNone': 'Keine Interessen gespeichert. Du kannst welche in der Kino-Suche wählen.',
  'tree.futureTag': 'Idee für später',
  'tree.futureCredential':
    'Zertifikate sind nur eine Idee für die Zukunft. Kids World vergibt keine Zertifikate oder Noten.',
  'tree.reason.no-attempts': 'Zu dieser Idee wurde noch keine Aufgabe versucht.',
  'tree.reason.tried-not-solved': '„{challenge}“ ist noch nicht gelöst.',
  'tree.reason.solved-with-show-me':
    '„{challenge}“ wurde mit „Zeig es mir“ gelöst, das ist ein Anfang.',
  'tree.reason.solved-entry': '„{challenge}“ wurde gelöst.',
  'tree.reason.solved-harder-with-help':
    'Die schwerere Aufgabe „{challenge}“ wurde mit etwas Hilfe gelöst.',
  'tree.reason.solved-harder-independently':
    'Die schwerere Aufgabe „{challenge}“ wurde selbst gelöst.',
  'tree.ev.solved': '„{challenge}“: gelöst',
  'tree.ev.notYet': '„{challenge}“: noch nicht gelöst',
  'tree.ev.harder': 'schwerere Stufe',
  'tree.ev.entry': 'erste Stufe',
  'tree.ev.tests': 'Tests: {count}',
  'tree.ev.hints': 'Tipps: {count}',
  'tree.ev.showMe': '„Zeig es mir“ benutzt',
  'tree.ev.ownWay': 'selbst',
  'tree.ev.chosen': 'selbst gewählt',
  'tree.byDay': 'Tagsüber: {line}',
  'tree.atNight': 'Nachts: {line}',
  'tree.sampleProject.firstRoom': 'Mein erster Raum',
  'tree.sampleProject.nightLight': 'Nachtlicht',
  'shell.sampleActive': 'Erfundenes Beispiel · {profile}',
  'shell.sampleBack': 'Zurück zu meinen Sachen',
  'offer.title': '{broadcaster} bietet {place} nicht an',
  'offer.body':
    'Jeder Sender wählt, welche Orte er anbietet. Am Europa-Globus kannst du einen anderen Sender wählen.',
  'offer.kept': 'Alles, was du in diesem Browser gespeichert hast, bleibt erhalten.',
  'offer.globe': 'Zum Europa-Globus',
  'offer.town': 'Zurück in die Stadt',
  'hub.notOffered': 'Hier nicht angeboten',
  'tree.samplesNotOffered': '{broadcaster} bietet keine Beispiel-Lernenden an.',
  'kids.readAloud': 'Lies es mir vor',
  'kids.who.title': 'Wer spielt?',
  'kids.little': 'Ich bin klein',
  'kids.littleAges': '3–8',
  'kids.bigger': 'Ich bin größer',
  'kids.biggerAges': '9+',
  'kids.who.say':
    'Wer spielt? Tippe auf den Hasen, wenn du klein bist. Tippe auf die Rakete, wenn du größer bist.',
  'kids.change': 'Ändern, wer spielt',
  'kids.town.say': 'Wohin möchtest du? Tippe auf ein Bild.',
  'time.chipLabel': 'Heute noch {minutes} Minuten Bildschirmzeit',
  'time.chip': 'noch {minutes} Min.',
  'time.finish': 'Die Zeit ist um — dieser Film läuft bis zum Ende',
  'rest.title': 'Zeit zum Ausruhen!',
  'rest.body': 'Die Bildschirmzeit für heute ist aufgebraucht. Bis morgen!',
  'grown.button': 'Für Erwachsene',
  'grown.title': 'Für Erwachsene',
  'grown.hold': 'Erwachsene: Taste 3 Sekunden lang gedrückt halten.',
  'grown.holdButton': 'Halten',
  'grown.noLimit': 'Kein Limit',
  'grown.minutes': '{minutes} Min.',
  'grown.timeTitle': 'Bildschirmzeit heute',
  'grown.timeIntro':
    'Kids World zeigt nur Filme, die in die verbleibende Zeit passen, und hält keinen mittendrin an. Ist die Zeit aufgebraucht, verabschiedet es sich nach dem Film.',
  'grown.used': 'Heute genutzt: {minutes} Min.',
  'grown.settings': 'Sender, Sprache und Daten',
  'grown.save': 'Speichern',
  'grown.close': 'Schließen',
  'room.hint.little': 'Tippe auf ein Bild!',
  'room.hint.bigger': 'Wähle einen Film',
  'room.say': 'Du bist im Kino! Tippe auf ein Bild, um zu schauen.',
  'room.soonSay': 'Diesen Film gibt es hier noch nicht.',
  'room.laterSay': 'Dieser Film ist für heute zu lang. Nächstes Mal!',
  'room.back': 'Zurück in die Stadt',
  'room.films': 'Filme',
  'room.watch': '{title} ansehen ({minutes} Min.)',
  'room.laterLabel': '{title}: für heute zu lang',
  'room.soonLabel': '{title}: hier noch nicht',
  'room.later': 'Nächstes Mal',
  'room.soon': 'Noch nicht da',
  'room.minutes': '{minutes} Min.',
  'room.play': 'Abspielen',
  'room.pause': 'Pause',
  'room.stop': 'Film anhalten',
  'room.details': 'Über diesen Film',
  'room.all': 'Alle Filme',
  'room.loading': 'Kino wird geöffnet …',
};
